import { combineReducers } from 'redux';
import uploadsReducer from './uploads';

const componentsReducer = combineReducers({
  uploads: uploadsReducer,
});

export default componentsReducer;
